/* @flow */
// typecheck: ignore file
import React from 'react';
import invariant from 'invariant';

import TitleHeader from 'components/TitleHeader.jsx';
import Dialog from 'components/Dialog.jsx';
import Avatar from 'components/Avatar.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import OrgRoleDropdown from 'groups/components/OrgRoleDropdown.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Text from 'components/Text.jsx';
import User from 'entities/User';

import './styles/BatchRoleCorrectionModal.scss';

type Props = {
  group: Group,
  loading?: bool,
  onClose?: ?Function,
  groupMemberships: GroupMembership[],
  onUserRoleSave?: (userId: number) => any,
  onRequestHide?: () => any, // From mountModal
};

class BatchRoleCorrectionModal extends React.Component {
  props: Props;

  componentWillUnmount() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  renderMemberRow(member: GroupMembership) {
    const user: User = member.getUser();
    const orgAffView = member.getOrgAffiliationView();
    invariant(orgAffView, 'member missing org_affiliation_view');

    return (
      <tr key={member.id}>
        <td className="BatchRoleCorrectionModal-table-nameRow">
          <Avatar
            size="medium"
            text={user.getInitials()}
            colorHex={user.getColor()}
          />
          <Text truncate className="BatchRoleCorrectionModal-table-nameRow-name">
            {user.getFullName()}
          </Text>
        </td>
        <td>
          <div className="BatchRoleCorrectionModal-table-organizationDropdown">
            <OrgRoleDropdown
              userId={user.id}
              name={user.getFullName()}
              group={this.props.group}
              roles={orgAffView.roles}
              potentialRoles={orgAffView.potential_roles}
              onSave={this.props.onUserRoleSave}
              canHaveRoleChanged={orgAffView.can_have_role_changed}
            />
          </div>
        </td>
      </tr>
    );
  }

  render() {
    const { onRequestHide, groupMemberships, loading } = this.props;

    return (
      <Dialog onRequestHide={onRequestHide} eventScreenName="BatchRoleCorrectionModal" className="BatchRoleCorrectionModal">
        <div className="BatchRoleCorrectionModal-body">
          <TitleHeader title="Modify Roles" />
          <table className="BatchRoleCorrectionModal-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {groupMemberships.map((m) => this.renderMemberRow(m))}
            </tbody>
          </table>
          {loading &&
            <div className="BatchRoleCorrectionModal-loadingIndicator">
              <LoadingIndicator size="small" />
            </div>
          }
        </div>
      </Dialog>
    );
  }
}

export default BatchRoleCorrectionModal;



// WEBPACK FOOTER //
// ./src/users/components/BatchRoleCorrectionModal.jsx